import React, { useEffect } from 'react';
import SharedButton from '../../components/Shared/SharedButton';
import { useTranslation } from 'react-i18next';
import LeaveTable from './LeaveTable';
import { useNavigate } from 'react-router-dom';
import useFetchData from '../../hooks/useFetchData';

export default function LeaveMain() {
  const { data: leavesData, loading, executeFetch } = useFetchData();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    executeFetch("POST", "leaves/list", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "leaves/list", { page: newPage, per_page: newRowsPerPage });
  };

  const handleRefresh = () => {
    executeFetch("POST", "leaves/list", { page: 1, per_page: 10 });
  };

  return (
    <>
      <div>
        <div className='flex justify-end mb-2 '>
          <SharedButton
            label={t('CreateLeave')}
            icon='pi pi-plus'
            onClick={() => navigate('/manager/leave/create')}
            className='bg-primary primary-btn'
          />
        </div>
        <LeaveTable
          data={leavesData}
          loading={loading}
          onPageChange={handlePageChange}
          onRefresh={handleRefresh}
        />
      </div>
    </>
  );
}
